@if (label) {
  <label for="weekSelectionId">{{ label }}</label>
}
<p-float-label [variant]="labelLocation">
  <p-button
    [icon]="defaultIcon.Previous"
    styleClass="vertical-align-middle"
    (click)="moveBackWeek()"
    pTooltip="Prior Week"
    />
    <p-date-picker
      #calendar
      [showIcon]="true"
      [(ngModel)]="controlValue"
      inputId="weekSelectionId"
      view="month"
      dateFormat="MM yy"
      [showClear]="false"
      appendTo="body"
      inputStyleClass="date-Format"
      (onSelect)="onChange()"
      (onblur)="onChange()"
      (onClear)="onChange()"
      (onShow)="onShow()"
      (onClose)="onClose()"
      [touchUI]="layoutService.mobile$ | async"
      [required]="required"
      [size]="size"
      />
      <p-button [icon]="defaultIcon.Today" styleClass="vertical-align-middle" (click)="moveToToday()" pTooltip="Today" />
      <p-button
        [icon]="defaultIcon.Next"
        styleClass="vertical-align-middle"
        (click)="moveForwardWeek()"
        pTooltip="Next Week"
        />
      </p-float-label>
